import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapperStyles = css`
  background: linear-gradient(90deg, rgba(44,31,66,1) 0%, rgba(0,0,0,1) 100%);
  display: flex;
  position: relative;
  width: 100%;
  min-height: 613px;

  ${media.max(BreakPoints.phone)} {
    min-height: 460px;
  }
  border-top: 1px solid ${colors.yellow};
  border-bottom: 1px solid ${colors.yellow};
`
export const NewContentStyles = css`
  padding: 32px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #FFFFFF27;
  ${media.max(BreakPoints.phone)} {
    padding: 13px 0;
  }
`
export const ContentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  max-width: 1305px;
  z-index: 2;
  padding-bottom: 61px;

  ${media.max(BreakPoints.lgDesktop)} {
    max-width: 1138px;
  }

  ${media.max(BreakPoints.desktop)} {
    max-width: 918px;
  }
`
export const NewsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  margin: 0;
`
export const SectionNameStyles = css`
  ${media.max(BreakPoints.phone)} {
    margin: 31px 0 16px 8px;
  }

  margin: 48px 0 26px;
  color: ${colors.white};
  font-size: 20px;
  font-weight: ${fonts.weights.medium};
`
export const NewLeftBlockStyles = css`
  flex: 0 0 30%;
  max-width: 336px;
  ${media.max(BreakPoints.phone)} {
    flex: 0 0 43%;
  }
`
export const NewRightBlockStyles = css`
  flex: 0 0 70%;
  ${media.max(BreakPoints.lgDesktop)} {
    flex: 0 0 66%;
  }
  ${media.max(BreakPoints.phone)} {
    flex: 0 0 50%;
 }

`

export const NewAssetWrapperStyles = css`
  width: 100%;
  overflow: hidden;
`

export const NewAssetStyles = css`
  width: 100%;
  ${media.max(BreakPoints.desktop)} {
    width: 130%;
    margin-left: -39px;
  }
  ${media.max(BreakPoints.phone)} {
    width: 100%;
    margin-left: 1px;
  }
`
export const NewTitleStyles = css`
  margin: 24px 0 1px;
  color: ${colors.white};
  font-size: 17px;
  font-weight: ${fonts.weights.light};
  ${media.max(BreakPoints.tablet)} {
    margin: 14px 0 1px;
  }
  ${media.max(BreakPoints.phone)} {
    margin: 6px 0 1px;
    font-size: 15px;
  }
`
export const LoadMoreButtonStyles = css`
  margin: 53px 0 16px;
  display: flex;
  justify-content: center;
`
export const NewGameNameStyles = css`
  margin: 24px 0 1px;
  color: ${colors.darkGray};
  font-size: 13px;
  font-weight: ${fonts.weights.light};
  display: flex;
  justify-content: space-between;
  ${media.max(BreakPoints.tablet)} {
    margin: 14px 0 1px;
  }
  ${media.max(BreakPoints.phone)} {
    margin: 6px 0;
    font-size: 12px;
  }
`

export const NewGameDateStyled = css`
  ${media.max(BreakPoints.phone)} {
    display: none;
  }
`

export const NewDescriptionStyles = css`
  margin: 24px 0;
  color: ${colors.white};
  font-size: 14px;
  font-weight: ${fonts.weights.light};
  ${media.max(BreakPoints.tablet)} {
    margin: 14px 0;
  }
  ${media.max(BreakPoints.phone)} {
    display: none;
  }
`
export const NewLinkStyles = css`
  & > a {
    color: ${colors.yellow};
    font-size: 17px;
    font-weight: ${fonts.weights.medium};
    ${media.max(BreakPoints.phone)} {
      font-size: 15px;
    }
  }
`
